import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminSurveyStepsRouteProps */

/** @typedef {object} RoutesAdminSurveyStepsRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminSurveyStepsRouteProps, RoutesAdminSurveyStepsRouteState>}
 */
class RoutesAdminSurveyStepsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="surveys">
        <Route component="edit" exact path="new" />
        <Route component="edit" exact path=":survey_step_id/edit" />
        <Route component="show" exact path=":survey_step_id" />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminSurveyStepsRoute))
